import { MktLogo } from '@playbooks/components/mkt/mkt-logo';
import { Link } from '@playbooks/ui/components/link';

const IndexSplashHeader = () => {
	const docsClient = process.env.NEXT_PUBLIC_DOCS_CLIENT || '/docs';
	return (
		<header className='h-16 border-b border-border px-3'>
			<div className='mx-auto flex-between h-full w-full max-w-xxl gap-6 px-3'>
				<MktLogo />
				<nav aria-label='Splash navigation' className='ml-auto flex-end gap-1'>
					<Link variant='ghost' size='xs' href={docsClient} target='_blank' className='font-normal'>
						Docs
					</Link>
					<Link variant='ghost' size='xs' href='/contact' className='font-normal'>
						Contact
					</Link>
				</nav>
			</div>
		</header>
	);
};
export { IndexSplashHeader };
